import { useAICapabilitiesEnabled } from '@/modules/tenant/TenantDetailsContext/hooks/useAICapabilitiesEnabled';

export function useHasHouseholdChat() {
  const aiEnabled = useAICapabilitiesEnabled();

  return Boolean(aiEnabled);
}
